export default "assets/images/swiper_next-fa8447e6.png";